import { cn } from '@repo/utils';

type TrendDir = 'up' | 'down' | 'flat';

interface StatCardProps {
  label: string;
  value: React.ReactNode;
  trend?: { direction: TrendDir; label: string };
  className?: string;
}

const trendColors: Record<TrendDir, string> = {
  up: 'text-success-text',
  down: 'text-danger-text',
  flat: 'text-text-muted',
};

const trendArrows: Record<TrendDir, string> = {
  up: '↑',
  down: '↓',
  flat: '→',
};

export function StatCard({ label, value, trend, className }: StatCardProps) {
  return (
    <div
      className={cn(
        'bg-surface-1 rounded-[10px] p-6 flex flex-col gap-2 shadow-sm',
        className,
      )}
    >
      <span className="text-xs font-medium text-text-secondary uppercase tracking-wide">
        {label}
      </span>
      <div className="text-2xl font-semibold text-text-primary tnum leading-tight">
        {value}
      </div>
      {trend && (
        <span className={cn('text-xs font-medium', trendColors[trend.direction])}>
          {trendArrows[trend.direction]} {trend.label}
        </span>
      )}
    </div>
  );
}
